import { get } from 'lodash';
import {
  computedCallingPlans,
  computedPbxPlans,
  computedPbxTollFreePlans,
} from '@/common/service/computers/plans/pbx';
import { mapGetters } from 'vuex';
import { BILLING_CYCLE } from '@/common/constants';

export default {
  computed: {
    ...mapGetters(['getSelectedPlans', 'planMapFlat']),
    allPbxPlans() {
      return computedPbxPlans(this.planMapFlat);
    },
    allTollFreePlans() {
      return computedPbxTollFreePlans(this.allPbxPlans);
    },
    selectedPbxPlans() {
      return computedPbxPlans(this.getSelectedPlans);
    },
    selectedCallingPlans() {
      return computedCallingPlans(this.getSelectedPlans);
    },
    selectedTollFreePlans() {
      return computedPbxTollFreePlans(this.getSelectedPlans);
    },
    selectedCallingPlan() {
      return get(this.selectedCallingPlans, [0], {});
    },
    // selected calling plan Name
    callingPlanName() {
      return this.$t(this.selectedCallingPlan.planNameKey);
    },
    pbxBillingCycle() {
      return get(this.selectedCallingPlans, '0.billing_cycle', BILLING_CYCLE.ANNUAL);
    },
  },
};
